






























import { CatalogFieldsForm, ResultMappingsForm, UiTextbox } from '../../components';

export default {
  name: 'catalog-form',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    CatalogFieldsForm,
    ResultMappingsForm,
    UiTextbox
  },
  data: function () {
    return {
      messages: this.$epb.messages.tools.instances.fields.catalog
    };
  }
};
